import { render, staticRenderFns } from "./payment-state-chip.vue?vue&type=template&id=98148fc2&scoped=true&"
import script from "./payment-state-chip.vue?vue&type=script&lang=js&"
export * from "./payment-state-chip.vue?vue&type=script&lang=js&"
import style0 from "./payment-state-chip.vue?vue&type=style&index=0&id=98148fc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98148fc2",
  null
  
)

export default component.exports